import { standardProductUnitCategories } from '../constants/productUnitCategories'
import { ProductUnitCategory } from '../enums/productUnitCategory'
import type { ProductUnit } from '../types/productUnit'

// Units with an unknown category are treated as custom ones
export const getProductUnitCategory = (unit: ProductUnit): ProductUnitCategory =>
  standardProductUnitCategories.includes(unit.category) ? unit.category : ProductUnitCategory.Custom
